import React, { useCallback, useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { TimeFilter } from '../filters/TimeFilter';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { renderTimeViewClock, TimePicker } from '@mui/x-date-pickers';
import { debounce } from 'lodash';

export const SPTimeField: FieldComponent<any, any> = ({
  onChange,
  defaultValue,
  forcedValue,
  disabled,
  isMissing,
}) => {
  const [open, setOpen] = useState(false);

  const [currentState, setCurrentState] = useState<any>({
    value: null,
    send: false,
  });

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, 500),
    []
  );

  useEffect(() => {
    if (defaultValue) {
      setCurrentState({
        value: dayjs(defaultValue, 'HH:mm'),
        send: false,
      });
    }
  }, [defaultValue]);

  useEffect(() => {
    if (currentState.send) {
      debouncedChange(currentState.value);
    }
  }, [currentState, debouncedChange]);

  const handleChange = (value: any) => {
    setCurrentState({
      value: value,
      send: true,
    });
  };

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          sx={{
            width: '100%'
          }}
          disabled={disabled}
          slotProps={{ textField: { size: 'small' } }}
          ampm={false}
          defaultValue={dayjs(defaultValue, 'HH:mm')}
          views={['hours', 'minutes']}
          onChange={(newValue: any) => {
            const datetime = dayjs(newValue, 'HH:mm').format('HH:mm');
            if (datetime !== 'Invalid Date') {
              handleChange(dayjs(newValue, 'HH:mm').format('HH:mm'));
            } else {
              handleChange(null);
            }
          }}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          open={open}
          viewRenderers={{
            hours: renderTimeViewClock,
            minutes: renderTimeViewClock,
            seconds: renderTimeViewClock,
          }}
        />
      </LocalizationProvider>
    </>
  );
};

SPTimeField.includes = (query, value) => true;

SPTimeField.comparator = () => 0;

SPTimeField.FilterRenderer = TimeFilter;
